export const CHANGE_FORGOT_PASSWORD_FORM_FIELD = 'CHANGE_FORGOT_PASSWORD_FORM_FIELD' as const
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST' as const
export const FORGOT_PASSWORD_REQUEST_SUCCESS = 'FORGOT_PASSWORD_REQUEST_SUCCESS' as const
export const FORGOT_PASSWORD_REQUEST_FAILURE = 'FORGOT_PASSWORD_REQUEST_FAILURE' as const
export const VALIDATE_FORGOT_PASSWORD_FIELD = 'VALIDATE_FORGOT_PASSWORD_FIELD' as const
export const ADD_FORGOT_PASSWORD_FIELD_ERROR = 'ADD_FORGOT_PASSWORD_FIELD_ERROR' as const
export const CLEAR_FORGOT_PASSWORD_FIELD_ERROR = 'CLEAR_FORGOT_PASSWORD_FIELD_ERROR' as const

export function changeForgotPasswordFormField(key: string, value: string) {
  return { type: CHANGE_FORGOT_PASSWORD_FORM_FIELD, payload: { key, value } }
}

export function forgotPasswordRequest({
  email,
}: {
  email: { value: string; validations?: string }
}) {
  return { type: FORGOT_PASSWORD_REQUEST, payload: { email } }
}

export function forgotPasswordFailure(errors: Record<string, string>) {
  return { type: FORGOT_PASSWORD_REQUEST_FAILURE, errors }
}

export function forgotPasswordSuccess() {
  return { type: FORGOT_PASSWORD_REQUEST_SUCCESS }
}

export function addFieldError({ field, error }: { field: string; error: string }) {
  return { type: ADD_FORGOT_PASSWORD_FIELD_ERROR, payload: { error, field } }
}

export function clearFieldError({ field }: { field: string }) {
  return { type: CLEAR_FORGOT_PASSWORD_FIELD_ERROR, payload: { field } }
}

export function validateField({
  field,
  value,
  validations,
}: {
  field: string
  value: string
  validations?: string
}) {
  return { type: VALIDATE_FORGOT_PASSWORD_FIELD, payload: { field, value, validations } }
}
